import { usePersonalSetting } from './usePersonalSetting';
import type { BooleanPersonalSetting } from './personalSettingOperations';

/** A boolean personal setting that reads as `false` until it is stored. */
export const usePersonalSettingToggle = (
  personalSetting: BooleanPersonalSetting
): [boolean, VoidFunction] => {
  const [storedValue, setValue] = usePersonalSetting(personalSetting);
  const value = storedValue ?? false;
  return [value, () => setValue(!value)];
};
